module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_txt2_en.bb5392d9df142ff80666f9151da960c3.png";